import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-submit-success',
  templateUrl: './submit-success.component.html',
  styleUrls: ['./submit-success.component.scss']
})

export class SubmitSuccessComponent implements OnInit {

  constructor() {}

  ngOnInit() {}

}
